<template>
    <information-popup modal-id="inscriptionGuidelinesPopup" v-bind:info="info">
        <template slot="header">Inscription Guidelines</template>
        <slot>
            <div class="modal-body">
                Your personalized message can be engraved with up to {{ info.max_chars }} characters per line, including blank spaces.
                A character is any letter, number, or punctuation mark found on a standard English keyboard.
                All text will automatically be centered and engraved in UPPERCASE letters.
                Messages containing websites, phone numbers, Twitter handles, and/or manifestos are not permitted.
                Texas Christian University reserves the right to approve all brick inscription.
                Discriminatory, political, offensive or inappropriate messages as determined
                by Texas Christian University will be declined and will require a new inscription to be submitted.
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-guidelines',
        props: {
            info: {
                type: Object, // can be modified by child component
                required: false,
                default: function () {
                    return {
                        max_chars: 16 // minimal known value as default
                    };
                }
            }
        },
        components: {
            'information-popup': InformationPopup
        }
    }
</script>



// WEBPACK FOOTER //
// InscriptionGuidelines.vue?758effe7